"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiMeta {
    static isOpen(token) {
        let url = `/meta/business-hours/open`;
        return Client_1.default.httpGet(url, token);
    }
    static isMaintenance(token) {
        let url = `/meta/maintenance`;
        return Client_1.default.httpGet(url, { token, client: null });
    }
    // Returns an empty Ok
    static updateMfaReminder(token) {
        let url = `/meta/mfa-reminder`;
        return Client_1.default.httpPost(url, token, {});
    }
    static getMfaReminderStatus(token) {
        let url = `/meta/mfa-reminder`;
        return Client_1.default.httpGet(url, token);
    }
    // Unused
    static getVerificationOfEmploymentInstructions(token) {
        let url = `/meta/verification-of-employment-instructions`;
        return Client_1.default.httpGet(url, token);
    }
    static getGlobalUnauthenticatedFeatures() {
        let url = `/meta/global-features`;
        return Client_1.default.httpGetUnauthenticated(url, true);
    }
}
exports.default = ApiMeta;
